import { Link } from 'react-router-dom';
import { Instagram, MapPin, Mail, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_5aeb9d65-c68c-4f8e-b371-f49441118154/artifacts/y8ms66px_06.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <img src={LOGO_URL} alt="ACEC Logo" className="h-16 w-auto" />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              Associação Canaã Esporte Clube Voleibol Feminino - Transformando vidas através do voleibol.
            </p>
            <div className="flex gap-4 pt-2">
              <a
                href="https://www.instagram.com/acecfeminino"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 hover:bg-blue-700 p-2.5 rounded-full transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.tiktok.com/@acec.feminino"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 hover:bg-blue-700 p-2.5 rounded-full transition-colors"
                data-testid="footer-tiktok"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h4 className="font-heading text-lg uppercase tracking-wider mb-4 text-yellow-400">
              Links Rápidos
            </h4>
            <ul className="space-y-3">
              {[
                { name: 'Sobre Nós', path: '/sobre' },
                { name: 'Nossa Jornada', path: '/jornada' },
                { name: 'Equipe', path: '/equipe' },
                { name: 'Conquistas', path: '/conquistas' },
                { name: 'Galeria', path: '/galeria' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="font-heading text-lg uppercase tracking-wider mb-4 text-yellow-400">
              Contato
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <MapPin size={18} className="text-blue-500 flex-shrink-0 mt-0.5" />
                <span>Canaã dos Carajás, Pará, Brasil</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Mail size={18} className="text-blue-500 flex-shrink-0" />
                <span>contato@acecfeminino.com.br</span>
              </li>
            </ul>
          </div>

          {/* Apoie */}
          <div>
            <h4 className="font-heading text-lg uppercase tracking-wider mb-4 text-yellow-400">
              Apoie o Projeto
            </h4>
            <p className="text-slate-400 text-sm mb-4">
              Ajude a transformar vidas através do esporte. Sua contribuição faz a diferença!
            </p>
            <Link
              to="/apoie"
              data-testid="footer-cta-apoie"
              className="inline-block bg-yellow-400 text-blue-900 hover:bg-yellow-300 rounded-full px-6 py-2.5 font-bold uppercase text-sm tracking-wider transition-all"
            >
              Seja um Apoiador
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} ACEC Feminino. Todos os direitos reservados.
          </p>
          <div className="flex gap-6">
            <Link to="/admin" className="text-slate-500 hover:text-white text-sm transition-colors" data-testid="admin-link">
              Área Administrativa
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
